import React, { Fragment } from 'react';
import { StyledTableContainer } from 'custom/components';
import { Box, Button, Collapse, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Stack, Typography } from '@mui/material';
import styles from '../../../../../custom/style.module.css';
import fltStyles from './fltloadinfo.module.css';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
// import Invoice from './invoice/Invoice';
function formatNumber(num) {
  return num % 1 === 0 ? Math.round(num) : num.toFixed(2);
}

const ContractData = (props) => {

  const handleQuantity = (row) => {
    let value = 0;
    if (props.billingFields?.exclude_disc) {
      if (props.billingFields?.transit === 'none' || !props.billingFields?.transit) {
        value = typeof row.quantity === 'number' ? formatNumber(Math.round(row.quantity * 100) / 100) : row.quantity;
      } else if (props.billingFields?.transit === 'inbound') {
        value = typeof row.in_quantity === 'number' ? formatNumber(Math.round(row.in_quantity * 100) / 100) : row.in_quantity;
      } else if (props.billingFields?.transit === 'outbound') {
        value = typeof row.out_quantity === 'number' ? formatNumber(Math.round(row.out_quantity * 100) / 100) : row.out_quantity;
      } else if (props.billingFields?.transit === 'flight' && props.billingFields?.priority === 'inbound') {
        value = typeof row.in_fquantity === 'number' ? formatNumber(Math.round(row.in_fquantity * 100) / 100) : row.in_fquantity;
      } else if (props.billingFields?.transit === 'flight' && props.billingFields?.priority === 'outbound') {
        value = typeof row.out_fquantity === 'number' ? formatNumber(Math.round(row.out_fquantity * 100) / 100) : row.out_fquantity;
      } else if (props.billingFields?.transit === 'truck' && props.billingFields?.priority === 'inbound') {
        value = typeof row.in_tquantity === 'number' ? formatNumber(Math.round(row.in_tquantity * 100) / 100) : row.in_tquantity;
      } else if (props.billingFields?.transit === 'truck' && props.billingFields?.priority === 'outbound') {
        value = typeof row.out_tquantity === 'number' ? formatNumber(Math.round(row.out_tquantity * 100) / 100) : row.out_tquantity;
      }
    } else {
      if (props.billingFields?.transit === 'none' || !props.billingFields?.transit) {
        value = typeof row.dis_quantity === 'number' ? formatNumber(Math.round(row.dis_quantity * 100) / 100) : row.dis_quantity;
      } else if (props.billingFields?.transit === 'inbound') {
        value = typeof row.dis_in_quantity === 'number' ? formatNumber(Math.round(row.dis_in_quantity * 100) / 100) : row.dis_in_quantity;
      } else if (props.billingFields?.transit === 'outbound') {
        value = typeof row.dis_out_quantity === 'number' ? formatNumber(Math.round(row.dis_out_quantity * 100) / 100) : row.dis_out_quantity;
      } else if (props.billingFields?.transit === 'flight' && props.billingFields?.priority === 'inbound') {
        value = typeof row.dis_in_fquantity === 'number' ? formatNumber(Math.round(row.dis_in_fquantity * 100) / 100) : row.dis_in_fquantity;
      } else if (props.billingFields?.transit === 'flight' && props.billingFields?.priority === 'outbound') {
        value = typeof row.dis_out_fquantity === 'number' ? formatNumber(Math.round(row.dis_out_fquantity * 100) / 100) : row.dis_out_fquantity;
      } else if (props.billingFields?.transit === 'truck' && props.billingFields?.priority === 'inbound') {
        value = typeof row.dis_in_tquantity === 'number' ? formatNumber(Math.round(row.dis_in_tquantity * 100) / 100) : row.dis_in_tquantity;
      } else if (props.billingFields?.transit === 'truck' && props.billingFields?.priority === 'outbound') {
        value = typeof row.dis_out_tquantity === 'number' ? formatNumber(Math.round(row.dis_out_tquantity * 100) / 100) : row.dis_out_tquantity;
      }
    }
    return (value === 0 || value == null) ? '0' : value;
  };

  const handleEqQuantity = (row) => {
    let value = 0;
    let orgvalue = 0;
    if (props.billingFields?.exclude_disc) {
      //if props.billingFields?.transit !== 'none'. Display  typeof row.quantity === 'number' ? formatNumber(Math.round(row.quantity * 100) / 100) : row.quantity; - the other quantity
      orgvalue = typeof row.quantity === 'number' ? formatNumber(Math.round(row.quantity * 100) / 100) : row.quantity;
      if (props.billingFields?.transit === 'none' || !props.billingFields?.transit) {
        value = typeof row.quantity === 'number' ? formatNumber(Math.round(row.quantity * 100) / 100) : row.quantity;
      } else if (props.billingFields?.transit === 'inbound') {
        value = typeof row.in_quantity === 'number' ? formatNumber(Math.round(row.in_quantity * 100) / 100) : row.in_quantity;
      } else if (props.billingFields?.transit === 'outbound') {
        value = typeof row.out_quantity === 'number' ? formatNumber(Math.round(row.out_quantity * 100) / 100) : row.out_quantity;
      } else if (props.billingFields?.transit === 'flight' && props.billingFields?.priority === 'inbound') {
        value = typeof row.in_fquantity === 'number' ? formatNumber(Math.round(row.in_fquantity * 100) / 100) : row.in_fquantity;
      } else if (props.billingFields?.transit === 'flight' && props.billingFields?.priority === 'outbound') {
        value = typeof row.out_fquantity === 'number' ? formatNumber(Math.round(row.out_fquantity * 100) / 100) : row.out_fquantity;
      } else if (props.billingFields?.transit === 'truck' && props.billingFields?.priority === 'inbound') {
        value = typeof row.in_tquantity === 'number' ? formatNumber(Math.round(row.in_tquantity * 100) / 100) : row.in_tquantity;
      } else if (props.billingFields?.transit === 'truck' && props.billingFields?.priority === 'outbound') {
        value = typeof row.out_tquantity === 'number' ? formatNumber(Math.round(row.out_tquantity * 100) / 100) : row.out_tquantity;
      }
    } else {
      orgvalue = typeof row.dis_quantity === 'number' ? formatNumber(Math.round(row.dis_quantity * 100) / 100) : row.dis_quantity;
      if (props.billingFields?.transit === 'none' || !props.billingFields?.transit) {
        value = typeof row.dis_quantity === 'number' ? formatNumber(Math.round(row.dis_quantity * 100) / 100) : row.dis_quantity;
      } else if (props.billingFields?.transit === 'inbound') {
        value = typeof row.dis_in_quantity === 'number' ? formatNumber(Math.round(row.dis_in_quantity * 100) / 100) : row.dis_in_quantity;
      } else if (props.billingFields?.transit === 'outbound') {
        value = typeof row.dis_out_quantity === 'number' ? formatNumber(Math.round(row.dis_out_quantity * 100) / 100) : row.dis_out_quantity;
      } else if (props.billingFields?.transit === 'flight' && props.billingFields?.priority === 'inbound') {
        value = typeof row.dis_in_fquantity === 'number' ? formatNumber(Math.round(row.dis_in_fquantity * 100) / 100) : row.dis_in_fquantity;
      } else if (props.billingFields?.transit === 'flight' && props.billingFields?.priority === 'outbound') {
        value = typeof row.dis_out_fquantity === 'number' ? formatNumber(Math.round(row.dis_out_fquantity * 100) / 100) : row.dis_out_fquantity;
      } else if (props.billingFields?.transit === 'truck' && props.billingFields?.priority === 'inbound') {
        value = typeof row.dis_in_tquantity === 'number' ? formatNumber(Math.round(row.dis_in_tquantity * 100) / 100) : row.dis_in_tquantity;
      } else if (props.billingFields?.transit === 'truck' && props.billingFields?.priority === 'outbound') {
        value = typeof row.dis_out_tquantity === 'number' ? formatNumber(Math.round(row.dis_out_tquantity * 100) / 100) : row.dis_out_tquantity;
      }
    }
    if( value === 0 || value == null ){
      // nothing 
      value = orgvalue - 0;
    } else {
      value = orgvalue - value;
      value = (Math.round(value * 100) / 100);
    }
    return (value === 0 || value == null) ? '' : '-'+value;
  };

  // const flightLoadColumns = [
  //   {
  //     field: 'item',
  //     headerName: 'Line Item',
  //     minWidth: 100,
  //     flex: 1.5,
  //   },
  //   {
  //     field: 'platform',
  //     headerName: 'Platform',
  //     minWidth: 100,
  //     flex: 1.5,
  //   },
  //   {
  //     field: 'driver',
  //     headerName: 'Driver',
  //     minWidth: 100,
  //     flex: 1,
  //   },
  //   {
  //     field: 'quantity',
  //     headerName: 'Quantity',
  //     minWidth: 100,
  //     flex: 1,
  //     renderCell: ({ row }) => {
  //       let value = 0;
  //       if (props.billingFields?.exclude_disc) {
  //         if (props.billingFields?.transit === 'none' || !props.billingFields?.transit) {
  //           value = typeof row.quantity === 'number' ? formatNumber(Math.round(row.quantity * 100) / 100) : row.quantity;
  //         } else if (props.billingFields?.transit === 'inbound') {
  //           value = typeof row.in_quantity === 'number' ? formatNumber(Math.round(row.in_quantity * 100) / 100) : row.in_quantity;
  //         } else {
  //           value = typeof row.out_quantity === 'number' ? formatNumber(Math.round(row.out_quantity * 100) / 100) : row.out_quantity;
  //         }
  //       } else {
  //         if (props.billingFields?.transit === 'none' || !props.billingFields?.transit) {
  //           value = typeof row.dis_quantity === 'number' ? formatNumber(Math.round(row.dis_quantity * 100) / 100) : row.dis_quantity;
  //         } else if (props.billingFields?.transit === 'inbound') {
  //           value = typeof row.dis_in_quantity === 'number' ? formatNumber(Math.round(row.dis_in_quantity * 100) / 100) : row.dis_in_quantity;
  //         } else {
  //           value = typeof row.dis_out_quantity === 'number' ? formatNumber(Math.round(row.dis_out_quantity * 100) / 100) : row.dis_out_quantity;
  //         }
  //       }
  //       return value === 0 ? 'Nil' : value;
  //     }
  //   },
  //   {
  //     field: 'source',
  //     headerName: 'Source',
  //     minWidth: 100,
  //     flex: 1,
  //   },
  //   // {
  //   //   field: 'recorded_from',
  //   //   headerName: 'Recorded from (# Flights)',
  //   //   minWidth: 100,
  //   //   flex: 1,
  //   // },
  // ];

  return <>
    <div className={`${styles.tableWrapper} ${styles.pt1}`}>
      {/* <Box className={`${styles.tableOuter} ${fltStyles.cdtableOuter}`}>
        <StyledDataGrid
          {...DataGridProps}
          rows={props.contractData}
          columns={flightLoadColumns}
          apiRef={props.apiRef}
          param={props.contractData?.length}
        />
      </Box> */}

      <StyledTableContainer className={`${fltStyles.collapsibleTableContainer} ${props.expanded ? fltStyles.expandedTable : ''}`} apiRef={props.apiRef}>
        <Table aria-label='collapsible table' stickyHeader className={fltStyles.collapsibleTable}>
          <TableHead className={fltStyles.collapsibleTableHead}>
            <TableRow className={fltStyles.collapsibleHeadRow}>
              <TableCell />
              <TableCell className={`${fltStyles.collapsibleTableCell}`}>Item</TableCell>
              <TableCell className={`${fltStyles.collapsibleTableCell}`}>Platform</TableCell>
              <TableCell className={`${fltStyles.collapsibleTableCell}`}>Driver</TableCell>
              <TableCell className={`${fltStyles.collapsibleTableCell}`}>Quantity</TableCell>
              <TableCell className={`${fltStyles.collapsibleTableCell}`}>Source</TableCell>
              <TableCell className={`${fltStyles.collapsibleTableCell} ${fltStyles.equalizedColumn}`}>Equalized Qty</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={fltStyles.collapsibleTableBody}>
            <TableRow sx={{
              '& > *': { borderBottom: 'unset' },
              height: 20 
            }}></TableRow>
            {
              props.contractData && props.contractData.length > 0 ?
                props.contractData.map((row, index) => (
                  <Fragment key={index}>
                    <TableRow key={index} className={fltStyles.collapsibleTableRow}>
                      <TableCell className={fltStyles.collapsibleTableCell} width={50}>
                        {row.children?.length > 0 &&
                          <IconButton
                            aria-label='expand row'
                            size='small'
                            onClick={() => props.handleTableCollapse(index)}
                            disabled={row.children?.length === 0}
                          >
                            {props.collapse.includes(index) ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                          </IconButton>}
                      </TableCell>
                      <TableCell width={'20%'} className={fltStyles.collapsibleTableCell}>{row.item}</TableCell>
                      <TableCell width={'20%'} className={fltStyles.collapsibleTableCell}>{row.platform}</TableCell>
                      <TableCell width={'20%'} className={fltStyles.collapsibleTableCell}>{row.driver}</TableCell>
                      <TableCell width={'20%'} className={fltStyles.collapsibleTableCell}>{handleQuantity(row)} </TableCell>
                      <TableCell width={'20%'} className={fltStyles.collapsibleTableCell}>{row.source}</TableCell>
                      <TableCell width={'20%'} className={`${fltStyles.collapsibleTableCell} ${fltStyles.equalizedColumn}`}>
                        <Stack direction='row' alignItems='center'>
                          <Typography component='span' variant='inherit' minWidth='60px' display='inline-block'>{handleEqQuantity(row)}</Typography>
                          {
                            props.transit_awbs && props.transit_awbs?.length > 0 && handleEqQuantity(row) && props.checkEqInvolved(props.transit_awbs, props.accord_type, props.billingFields, row.item) ?
                              <Tooltip title='View Transit AWBs present on Inbound/Outbound flights'> 
                                <Button variant='text' className={fltStyles.transitAwbButton}  onClick={() => props.showTransitAWBs(row.item, row.quantity, handleQuantity(row))}>Transit EQ</Button>
                              </Tooltip> : null
                          }
                        </Stack>
                      </TableCell>
                    </TableRow>
                    <TableRow className={fltStyles.spRow}>
                      <TableCell colSpan={6}>
                        <Collapse in={props.collapse.includes(index)} timeout='auto' unmountOnExit>
                          <Box className={fltStyles.collapsibleBox}>
                            <Table aria-label='' className={fltStyles.collapsedTable}>
                              <TableHead className={fltStyles.collapsedTableHead}>
                                <TableRow className={fltStyles.collapsedTableRow}>
                                  <TableCell className={`${fltStyles.collapsedTableCell}`}>Item</TableCell>
                                  <TableCell className={`${fltStyles.collapsedTableCell}`}>Platform</TableCell>
                                  <TableCell className={`${fltStyles.collapsedTableCell}`}>Driver</TableCell>
                                  <TableCell className={`${fltStyles.collapsedTableCell}`}>Quantity</TableCell>
                                  <TableCell className={`${fltStyles.collapsedTableCell}`}>Source</TableCell>
                                </TableRow>
                                <TableRow className={fltStyles.spRow} /> {/* add space between table head and the body */}
                              </TableHead>
                              <TableBody className={fltStyles.collapsedTableBody}>
                                {row?.children?.map((rowc, index) => (
                                  <TableRow key={index} className={fltStyles.collapsedTableRow}>
                                    <TableCell width={'20%'} className={fltStyles.collapsedTableCell}>{rowc.controw_data ? rowc.controw_data.label : rowc.label}</TableCell>
                                    <TableCell width={'20%'} className={fltStyles.collapsedTableCell}>{rowc.controw_data ? rowc.controw_data.platform : rowc.platform}</TableCell>
                                    <TableCell width={'20%'} className={fltStyles.collapsedTableCell}>{rowc.controw_data ? rowc.controw_data.applied_on?.split('|')[1].trim() : rowc.applied_on?.split('|')[1].trim()}</TableCell>
                                    <TableCell width={'20%'} className={fltStyles.collapsedTableCell}>{rowc.controw_data ? handleQuantity(rowc.controw_data) : handleQuantity(rowc)} </TableCell>
                                    <TableCell width={'20%'} className={fltStyles.collapsedTableCell}>{rowc.controw_data ? rowc.controw_data.applied_on?.split('|')[0].trim() : rowc.applied_on?.split('|')[0].trim()}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </Fragment>
                )):
                <TableRow>
                  <TableCell colSpan={6} align='center'>
                      No Rows Found
                  </TableCell>
                </TableRow>
            }
          </TableBody>
        </Table>
      </StyledTableContainer>
    </div>
  </>;

};

export default ContractData;